module.exports = __webpack_public_path__ + "img/HC1012-169.47b253c0.jpg";